import { format } from "date-fns";
import { da } from "date-fns/locale";

// declare global
// {
//     // eslint-disable-next-line no-var
//     var __localeId__: string;
// }

// globalThis.__localeId__ = "da";

export default function (date: Date, formatStr: string)
{
    return format(date, formatStr, { locale: da });
}